import { render, staticRenderFns } from "./PointCloud3DComponent.vue?vue&type=template&id=05bd1170&scoped=true"
import script from "./PointCloud3DComponent.vue?vue&type=script&lang=js"
export * from "./PointCloud3DComponent.vue?vue&type=script&lang=js"
import style0 from "./PointCloud3DComponent.vue?vue&type=style&index=0&id=05bd1170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd1170",
  null
  
)

export default component.exports